
export const projectProductPagePath = '/partner/projects/:projectSlug/:modelSlug';